export default __webpack_public_path__ + "static/MediaMainBanner-63466ddf68190a4f4f33ee093da7e184.webp";